<template>
    <div class="h5" v-loading="connecting" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="history">
            <h3 class="title">历史搜索</h3>
            <ul class="box" v-if="messages.length">
                <li class="item" v-for="(item,index) in messages" :key="index" @click="text=item">{{item}}<i class="icon el-icon-arrow-right"></i></li>
            </ul>
            <el-empty v-else :image-size="50"></el-empty>
        </div>
        
        <div class="bottom">
            <div class="input" v-if="type===1">
                <div class="main">
                    <MzInput v-model="text" type="textarea" :rows="4" placeholder="您可以语音或文字输入搜索"></MzInput>
                    <div class="flx-bc bar">
                        <span class="icon el-icon-microphone" @click="startRecord"></span>
                        <span class="icon el-icon-s-promotion" :class="!text || disabled?'disabled':''" @click="textSearch"></span>
                    </div>
                </div>
            </div>
            <div class="btn">
                <el-button type="primary" size="small" v-if="type===2&&!isRecording" @click="startRecord" :disabled="disabled">开始</el-button>
                <el-button type="primary" size="small" v-if="isRecording" @click="stopRecord()">停止</el-button>
                <span class="tip" v-if="tip">{{tip}}</span>
                <el-button v-if="tip.indexOf('刷新')>-1" style="margin-left:10px" type="text" @click="$router.go(0)">刷新</el-button>
            </div>
            <div class="tabs">
                <el-button :type="type===1?'primary':''" @click="change(1)">文字AI</el-button>
                <el-button :type="type===2?'primary':''" @click="change(2)">语音AI</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    props: {
    },
    data() {
        return {
            isRecording: false,
            startTime: '',
            connecting: true, //ai服务连接
            loadingText: '服务连接中',
            tip: '',
            text: '',
            type: 1, //1文字2语音
            messages: [],
            disabled: false,
            reconnectTimer: null,     // 重连定时器
            reconnectAttempts: 0,     // 重连尝试次数
            maxReconnectAttempts: 5,  // 最大重连次数
            wsConnected: false,       // WebSocket连接状态
            isUserClosed: false,      // 是否是用户主动关闭
            audioStream: null,
            audioContext: null,
            audioInput: null,
            scriptProcessor: null,
            audioChunks: [],
            speaking: false, //语音对话是否已连接
        }
    },
    created() {
        this.getHistory()
        this.initWebSocket()
    },
    mounted() {
    },
    beforeDestroy() {
        this.cleanupAi()
    },
    methods: {
        // 开始录制
        async startRecord() {
            if (this.isRecording) return;
            try {
                if(this.type === 2){
                    this.speaking = false
                    // 告诉服务端开始语音对话
                    this.voiceSearch(1, '');
                }
                this.text = ''
                this.audioChunks = []
                // 获取音频输入设备
                this.audioStream = await navigator.mediaDevices.getUserMedia({audio: true});
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)({
                    sampleRate: 16000
                });
                this.audioInput = this.audioContext.createMediaStreamSource(this.audioStream);

                // 设置缓冲区大小为2048的脚本处理器
                this.scriptProcessor = this.audioContext.createScriptProcessor(2048, 1, 1);

                const self = this;
                this.scriptProcessor.onaudioprocess = function (event) {
                    if(self.type===2 && !self.speaking){
                        console.log("语音连接未开始")
                        return
                    }
                    const inputData = event.inputBuffer.getChannelData(0);

                    const inputData16 = new Int16Array(inputData.length);
                    for (let i = 0; i < inputData.length; ++i) {
                        inputData16[i] = Math.max(-1, Math.min(1, inputData[i])) * 0x7FFF; // PCM 16-bit
                    }
                    
                    // 收集音频数据
                    self.audioChunks.push(inputData16);
                    
                    if (self.type===2 && self.checkWsConnection()) {
                        let arrayBuffer = inputData16.buffer;
                        let blob = new Blob([arrayBuffer]);
                        let reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = function () {
                            let base64String = reader.result.split(',')[1]; // 去掉前缀的 "data:[<mediatype>];base64,"
                            self.voiceSearch(0, base64String);
                        };
                    }
                };
                this.audioInput.connect(this.scriptProcessor);
                this.scriptProcessor.connect(this.audioContext.destination);
                this.isRecording = true;
                this.tip = this.type===1?'录音中':this.type===2&&this.speaking?'语音对话中':'语音连接中'
                this.startTime = Date.now()
            } catch (err) {
                this.$message({
                    message: '请允许麦克风权限',
                    type: 'error',
                    customClass: 'adminMsg'
                })
                console.error('获取麦克风失败:', err);
            }
        },
        // 停止录音
        stopRecord(stop=1) {            
            if (this.scriptProcessor) {
                this.scriptProcessor.disconnect();
                this.scriptProcessor = null;
            }
            if (this.audioInput) {
                this.audioInput.disconnect();
                this.audioInput = null;
            }
            if (this.audioStream) {
                this.audioStream.getTracks().forEach(track => track.stop());
                this.audioStream = null;
            }
            if (this.audioContext) {
                this.audioContext.close();
                this.audioContext = null;
            }
            this.isRecording = false;
            this.speaking = false
            this.tip = this.type===1?'录音结束':'语音对话结束'
            if(this.type === 1 && this.audioChunks.length > 0){
                // 合并所有音频数据
                const totalLength = this.audioChunks.reduce((acc, chunk) => acc + chunk.length, 0);
                const mergedBuffer = new Int16Array(totalLength);
                let offset = 0;
                for (const chunk of this.audioChunks) {
                    mergedBuffer.set(chunk, offset);
                    offset += chunk.length;
                }
                const blob = new Blob([mergedBuffer], { type: 'audio/pcm; sampleRate=16000' });
                this.uploadPcm(blob);
            }
            this.audioChunks = [];
            if(this.type === 2 && stop === 1){
                this.voiceSearch(2,'')
            }
        },
        // 上传 PCM语音识别请求
        uploadPcm(blob) {
            const formData = new FormData();
            formData.append('file', blob, 'record.pcm');
            formData.append('userId', '酪蛋白工厂');
            formData.append('cloud', '1');
            formData.append('index', this.startTime.toString()); // FormData 只接受字符串或 Blob
            axios.post(this.$baseUrl+"/api/comm/file/upload",formData).then(res => {
                if(res.code === 200){
                    console.log("上传音频成功")
                }
            })
        },
        // 文字搜索
        textSearch(){
            if(!this.text || this.disabled){
                return
            }
            let params = {
                userId: '酪蛋白工厂',
                text: this.text,
                index: Date.now()
            }
            this.disabled = true
            axios.post(this.$baseUrl+'/api/web/audio/text',params).then(res => {
                if(res.data.code === 200){
                    console.log("发送文字搜索成功")
                }
            }).finally(() => {
                this.disabled = false
            })
        },
        // 语音对话
        voiceSearch(state, base64Data = ''){
            if (!this.checkWsConnection()) {
                console.error('WebSocket未连接，无法发送语音数据');
                if (this.isRecording) {
                    this.stopRecord();
                }
                this.disabled = false
                return false;
            }
            try {
                let data = {
                    text: base64Data,
                    userId: '酪蛋白工厂',
                    state: state, //状态：1-开始，0-中间部分，2-结束
                    action: 'voice'
                }
                console.log('发送语音数据，状态:', state, '数据长度:', base64Data.length,'发送时间:',Date.now());
                this.websocket.send(JSON.stringify(data));
                return true;
            } catch (error) {
                console.error('发送语音数据失败:', error);
                this.tip = '发送语音数据失败，请重试';
                if (this.isRecording) {
                    this.stopRecord();
                }
                return false;
            }
        },
        change(type){
            if(this.type === type){
                return false
            }else{
                if(this.isRecording){
                    this.$message({
                        message: "录音中，请先停止",
                        type: 'error',
                        customClass: 'adminMsg'
                    })
                    return false
                }
            }
            this.type = type
            this.tip = ''
        },
        initWebSocket() {
            this.isUserClosed = false; // 初始化WebSocket时重置标志位
            this.connecting = true
            this.loadingText = '服务连接中'
            this.wsConnected = false
            const url = `${this.$wsUrl}/wss/audio?userId=酪蛋白工厂`
            this.websocket = new WebSocket(url);
            this.websocket.onopen = () => {
                console.log('WebSocket 已连接');
                this.connecting = false
                this.loadingText = ''
                this.tip = ''
                this.wsConnected = true
                this.reconnectAttempts = 0
                clearTimeout(this.reconnectTimer)
            };
            this.websocket.onmessage = (event) => {
                console.log("接收消息")
                let res = JSON.parse(event.data)
                console.log(res)
                if(res.code === 200){
                    if(res.type === 'text'){
                        this.text = res.data
                    }else if(res.type === 'text_search'){
                        this.connecting = true
                        this.loadingText = '努力思考中...'
                    }else if(res.type === 'voice'){
                        this.connecting = false
                        this.loadingText = ''
                        this.text = ''
                        this.getHistory()
                    }else if(res.type === 'damoxin'){
                    }else if(res.type === 'connect'){
                        // 语音对话开始后再录音
                        this.speaking = true
                        this.tip = this.type===2&&this.speaking?'语音对话中':'语音连接中'
                    }
                }else if(res.code === 600){
                    // 语音对话结束
                    this.stopRecord(0)
                }else{
                    console.log(res.msg)
                    this.tip = res.msg
                    this.connecting = false
                    this.loadingText = ''
                }
            };
            this.websocket.onerror = (err) => {
                console.error('WebSocket 错误:', err);
                this.$message({
                    message: "服务发生错误，正在重连",
                    type: 'error',
                    customClass: 'adminMsg'
                })
                this.handleWsClose()
            };
            this.websocket.onclose = (event) => {
                console.log('WebSocket 已关闭:', event.code, event.reason);
                this.wsConnected = false
                this.tip = '服务已关闭，正在重连...'
                this.handleWsClose()
            };
        },
        
        // WebSocket关闭处理
        handleWsClose() {
            // 清理现有连接
            if (this.websocket) {
                this.websocket.onopen = null;
                this.websocket.onmessage = null;
                this.websocket.onerror = null;
                this.websocket.onclose = null;
                this.websocket.close();
                this.websocket = null;
            }
            
            // 如果是用户主动关闭或清理AI，不再尝试重连
            if (this.isUserClosed) {
                console.log('用户主动关闭或清理AI，不进行重连');
                return;
            }
            
            // 尝试重连
            if (this.reconnectAttempts < this.maxReconnectAttempts) {
                this.reconnectAttempts++;
                const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 5000); // 指数退避
                this.reconnectTimer = setTimeout(() => {
                    console.log(`WebSocket 重连尝试 ${this.reconnectAttempts}/${this.maxReconnectAttempts}`);
                    this.initWebSocket();
                }, delay);
            } else {
                this.tip = '服务重连失败，请刷新页面重试';
                this.connecting = false;
            }
        },
        
        // 检查WebSocket连接状态
        checkWsConnection() {
            if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
                this.tip = '连接已断开，请等待重连或刷新页面';
                return false;
            }
            return true;
        },
        getHistory(){
            let params = {fileName: name}
            axios.post(this.$baseUrl+'/api/web/search/words',params).then(res => {
                if(res.data.code === 200){
                    this.messages = res.data.data
                }
            })
        },
        cleanupAi() {
            // 清理AI资源时，确保不再重连
            this.isUserClosed = true;
            
            // 先清理重连定时器，确保不会有延迟的重连尝试
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }
            
            // 关闭WebSocket前先移除事件监听器，避免触发onclose事件导致重复清理
            if (this.websocket) {
                this.websocket.onopen = null;
                this.websocket.onmessage = null;
                this.websocket.onerror = null;
                this.websocket.onclose = null;
                this.websocket.close();
                this.websocket = null;
            }
            
            // 清理音频相关资源
            if (this.scriptProcessor) {
                this.scriptProcessor.disconnect();
                this.scriptProcessor = null;
            }
            if (this.audioInput) {
                this.audioInput.disconnect();
                this.audioInput = null;
            }
            if (this.audioStream) {
                this.audioStream.getTracks().forEach(track => track.stop());
                this.audioStream = null;
            }
            if (this.audioContext) {
                this.audioContext.close();
                this.audioContext = null;
            }
            
            // 清理数据
            this.audioChunks = [];
            this.startTime = '';
            this.isRecording = false;
            this.reconnectAttempts = 0;
            this.wsConnected = false;
        },
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/h5';
</style>